import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Helmet>
        <title>CataractLensAdvisor | See Clearly Again</title>
        <meta name="description" content="Personalized lens recommendations designed by experts to help you regain your vision, confidence, and quality of life." />
      </Helmet>

      {/* Hero Section */}
      <section className="vibrant-hero">
        <div className="container vibrant-hero-container">
          <div className="hero-content-vibrant">
            <h1 className="vibrant-hero-title">
              See the World Clearly Again: Your Guide to the Right Cataract Lens
            </h1>
            <p className="vibrant-hero-subtitle">
              Personalized lens recommendations designed by experts to help you regain your vision, confidence, and quality of life.
            </p>
            <div className="vibrant-hero-cta">
              <Link to="/cataract-lens-questionnaire" className="btn btn-primary btn-large vibrant-cta">
                Start Your Lens Assessment
                <span className="material-symbols-outlined">arrow_forward</span>
              </Link>
            </div>
            <div className="social-proof">
              <div className="avatar-stack">
                <div className="avatar"></div>
                <div className="avatar"></div>
                <div className="avatar"></div>
              </div>
              <p>Joined by 10,000+ happy patients</p>
            </div>
          </div>
          <div className="hero-visual-vibrant">
            <div className="hero-image-vibrant-wrapper">
              <img 
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuA1rJVjBdvK8q3C_3bpRCAB1aibJdDNrw79BD8l6YJDUl3Ila8tDYuR3Z72Z8Ahcp-TtzKEEWEnUOxcQEN--BiKt_F3-wGT6Kh2EhxXh40e5DuHPVjJjT8aeoa8-jTldzsDmezJgZyqEkXhdOoR4ZoP8DQ4TbKZ5xJstwjDa6CL57RTcBJfJKo1xV_n5edghEV9lap4QfQrHsPXHIkBRfgvlXwLlgIziADKB1Qlofn3ZG_8V2kgmuSwfo7M54LLN_o-Z_zine2VEV4" 
                alt="Happy Senior Couple" 
                className="hero-vibrant-img"
              />
              <div className="vibrant-image-overlay"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="vibrant-trust">
        <div className="container">
          <div className="vibrant-section-header">
            <h2 className="vibrant-title">Why Trust Us?</h2>
            <p className="vibrant-subtitle">
              We provide unbiased, medical-grade guidance tailored to your unique lifestyle. Our goal is your clarity.
            </p>
          </div>
          <div className="vibrant-trust-grid">
            <div className="vibrant-trust-card">
              <div className="vibrant-icon-box">
                <span className="material-symbols-outlined">verified_user</span>
              </div>
              <h3>Expert-Reviewed</h3>
              <p>Every piece of information is verified by leading board-certified ophthalmologists.</p>
            </div>
            <div className="vibrant-trust-card">
              <div className="vibrant-icon-box">
                <span className="material-symbols-outlined">balance</span>
              </div>
              <h3>Unbiased Info</h3>
              <p>We don't represent any lens brands. Our recommendations are strictly based on clinical data.</p>
            </div>
            <div className="vibrant-trust-card">
              <div className="vibrant-icon-box">
                <span className="material-symbols-outlined">person_search</span>
              </div>
              <h3>Personalized</h3>
              <p>Algorithms that analyze your hobbies, driving habits, and daily needs for the perfect match.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="vibrant-how">
        <div className="container">
          <h2 className="vibrant-title text-center">How It Works</h2>
          <div className="vibrant-steps-container">
            <div className="steps-line"></div>
            <div className="vibrant-step">
              <div className="step-vibrant-icon">
                <span className="material-symbols-outlined">edit_note</span>
              </div>
              <h3>Take the Assessment</h3>
              <p>Answer 10 simple questions about your daily life, budget, and vision goals.</p>
            </div>
            <div className="vibrant-step">
              <div className="step-vibrant-icon">
                <span className="material-symbols-outlined">analytics</span>
              </div>
              <h3>Get Your Report</h3>
              <p>Receive a detailed comparison of lenses suited to your unique medical profile.</p>
            </div>
            <div className="vibrant-step">
              <div className="step-vibrant-icon">
                <span className="material-symbols-outlined">stethoscope</span>
              </div>
              <h3>Consult Your Doctor</h3>
              <p>Print or email your report to discuss final choices with your eye surgeon.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="vibrant-final-cta">
        <div className="container">
          <div className="vibrant-cta-box">
            <div className="cta-blur-bg"></div>
            <div className="cta-vibrant-content">
              <h2>Ready to regain your visual independence?</h2>
              <p>Join thousands of others who found their perfect match through our expert assessment tool.</p>
              <Link to="/cataract-lens-questionnaire" className="btn btn-primary btn-large vibrant-cta">
                Start Your Free Assessment
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
